import React from 'react';
import styled, { keyframes } from 'styled-components';

const LoaderWrap = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: #fff;
  z-index: 1;
`;

const LoadingText = styled.div`
  font-weight: bold;
  white-space: nowrap;
  width: 100%;
  text-align: center;
  ::after {
    animation-name: ${keyframes`
      0% { content: ""; }
      25% { content: "."; }
      50% { content: ".."; }
      75% { content: "..."; }
      100% { content: ""; }
    `};
  }
`;

interface LoaderProps {
  loadingText?: string;
  backgroundColor?: string;
}
const Loader: React.FC<LoaderProps> = ({ loadingText = 'Powered by CEMWARE', backgroundColor = 'white' }) => (
  <LoaderWrap style={{ backgroundColor } as React.CSSProperties}>
    <div className="loader-container">
      <div className="loader">
        <div className="loader--dot" />
        <div className="loader--dot" />
        <div className="loader--dot" />
        <div className="loader--dot" />
        <div className="loader--dot" />
        <div className="loader--dot" />
        {loadingText && (
          <LoadingText className="loader--text">{loadingText}</LoadingText>
        )}
      </div>
    </div>
  </LoaderWrap>
);

export default Loader;
